import { useStatsigClient } from '@statsig/react-bindings';

import { GATES } from '@constants';

/**
 * return proficiency tooltip content
 * @return {JSX}
 */
export const proficiencyTooltipContent = (
  <>
    <p>
      <strong>Beginner</strong> Limited to no knowledge of panel data.
    </p>
    <br />
    <p>
      <strong>Intermediate</strong> Understands data methodology, what is panel data and <br />
      difference between other data sets like POS.
    </p>
    <br />
    <p>
      <strong>Advanced</strong> In-depth knowledge of panel methodology and nuances of panel
      <br /> & POS metrics and formulas.
    </p>
  </>
);

/**
 * checks if the subscription overview is enabled
 * @returns {boolean}
 */
export const useSubscriptionV2 = () => {
  const { client } = useStatsigClient();
  return client.checkGate(GATES.MULTIPLE_SUBSCRIPTIONS_REVAMP);
};
